// Terms of Service

// Last updated: October 15, 2023

// Welcome to TELLMIZ ("we," "us," or "our"). These Terms of Service ("Terms") govern your access to and use of our mobile application TELLMIZ (the "App") and any related services. Please read these Terms carefully before using the App.

// By accessing or using the App, you agree to be bound by these Terms. If you do not agree with any part of the Terms, you may not access the App.

// 1. Acceptance of Terms
// By downloading, installing, or using the App, you:

// Acknowledge that you have read and understood these Terms.
// Agree to be legally bound by these Terms.
// Confirm that you are at least 13 years old (or the legal age in your jurisdiction).
// 2. Changes to Terms
// We reserve the right to modify or replace these Terms at any time. We will notify you of any changes by updating the "Last updated" date and, if the changes are significant, by providing additional notice (such as a notice within the App).

// 3. Use of the App
// 3.1 License
// We grant you a limited, non-exclusive, non-transferable, revocable license to use the App for personal, non-commercial purposes in accordance with these Terms.

// 3.2 User Conduct
// You agree not to:

// Use the App for any unlawful purpose.
// Violate any applicable laws or regulations.
// Transmit any harmful code or disrupt the App's security.
// Attempt to gain unauthorized access to any part of the App.
// 4. User Accounts
// 4.1 Account Creation
// To access certain features, you may need to create an account by providing accurate and complete information.

// 4.2 Account Security
// You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.

// 4.3 Account Termination
// We reserve the right to suspend or terminate your account at our sole discretion if you violate these Terms.

// 5. Intellectual Property
// All content, features, and functionality of the App—including but not limited to text, graphics, logos, and software—are owned by us or our licensors and are protected by intellectual property laws.

// 6. User-Generated Content
// 6.1 Content Ownership
// You retain ownership of any content you submit or post through the App ("User Content").

// 6.2 Content License
// By submitting User Content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and display such content in connection with the App.

// 6.3 Prohibited Content
// You agree not to submit any User Content that is illegal, offensive, or infringes on the rights of others.

// 7. Third-Party Services
// The App may contain links to third-party websites or services that are not owned or controlled by us. We are not responsible for the content or practices of any third-party sites.

// 8. Privacy Policy
// Your use of the App is also governed by our Privacy Policy, which is incorporated into these Terms by reference.

// 9. Disclaimers
// 9.1 No Warranty
// The App is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind, either express or implied.

// 9.2 Limitation of Liability
// In no event shall we be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of the App.

// 10. Indemnification
// You agree to indemnify and hold us harmless from any claims, losses, liabilities, damages, expenses, and costs arising from your use of the App or violation of these Terms.

// 11. Governing Law
// These Terms shall be governed by and construed in accordance with the laws of [Your Country/State], without regard to its conflict of law provisions.

// 12. Dispute Resolution
// Any disputes arising out of or relating to these Terms or the App shall be resolved through [arbitration/courts] located in [Your Jurisdiction].

// 13. Severability
// If any provision of these Terms is found to be unenforceable or invalid, the remaining provisions shall remain in full force and effect.

// 14. Entire Agreement
// These Terms constitute the entire agreement between you and us regarding the App and supersede any prior agreements.

// 15. Contact Us
// If you have any questions about these Terms, please contact us at:

// Email: [Contact Email Address]
// Address: [Company Address]

// TermsOfService.jsx

import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="tos-container">
      <h1 className="tos-heading">Terms of Service</h1>
      <p className="tos-date">Last updated: January 20, 2025</p>

      <p>
        Welcome to <strong>TELLMIZ</strong> ("we," "us," or "our"). These Terms of Service ("Terms") govern your
        access to and use of our mobile application <strong>TELLMIZ</strong> (the "App") and any related services.
        Please read these Terms carefully before using the App.
      </p>

      <p>
        By accessing or using the App, you agree to be bound by these Terms. If you do not agree with any part of the
        Terms, you may not access the App.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>By downloading, installing, or using the App, you:</p>
      <ul>
        <li>Acknowledge that you have read and understood these Terms.</li>
        <li>Agree to be legally bound by these Terms.</li>
        {/* <li>Confirm that you are at least 13 years old (or the legal age in your jurisdiction).</li> */}
      </ul>

      <h2>2. Changes to Terms</h2>
      <p>
        We reserve the right to modify or replace these Terms at any time. We will notify you of any changes by
        updating the "Last updated" date and, if the changes are significant, by providing additional notice (such as a
        notice within the App).
      </p>

      <h2>3. Use of the App</h2>
      <h3>3.1 License</h3>
      <p>
        We grant you a limited, non-exclusive, non-transferable, revocable license to use the App for personal,
        non-commercial purposes in accordance with these Terms.
      </p>

      <h3>3.2 User Conduct</h3>
      <p>You agree not to:</p>
      <ul>
        <li>Use the App for any unlawful purpose.</li>
        <li>Violate any applicable laws or regulations.</li>
        <li>Transmit any harmful code or disrupt the App's security.</li>
        <li>Attempt to gain unauthorized access to any part of the App.</li>
      </ul>

      {/* Continue adding the remaining sections in a similar fashion */}
      <h2>4. User Accounts</h2>
      <h3>4.1 Account Creation</h3>
      <p>
        To access features, you need to create an account by providing accurate and complete information.
      </p>

      <h3>4.2 Account Security</h3>
      <p>
        You are responsible for maintaining the confidentiality of your account credentials and for all activities that
        occur under your account.
      </p>

      <h3>4.3 Account Termination</h3>
      <p>
        We reserve the right to suspend or terminate your account at our sole discretion if you violate these Terms.
      </p>

      <h2>5. Intellectual Property</h2>
      <p>
        All content, features, and functionality of the App—including but not limited to text, graphics, logos, and
        software—are owned by us or our licensors and are protected by intellectual property laws.
      </p>

      <h2>6. User-Generated Content</h2>
      <h3>6.1 Content Ownership</h3>
      <p>You retain ownership of any content you submit or post through the App ("User Content").</p>

      <h3>6.2 Content License</h3>
      <p>
        By submitting User Content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce,
        modify, and display such content in connection with the App.
      </p>

      <h3>6.3 Prohibited Content</h3>
      <p>
        You agree not to submit any User Content that is illegal, offensive, or infringes on the rights of others.
      </p>

      <h2>7. Third-Party Services</h2>
      <p>
        The App may contain links to third-party websites or services that are not owned or controlled by us. We are not
        responsible for the content or practices of any third-party sites.
      </p>

      <h2>8. Privacy Policy</h2>
      <p>
        Your use of the App is also governed by our Privacy Policy, which is incorporated into these Terms by reference.
      </p>

      <h2>9. Disclaimers</h2>
      <h3>9.1 No Warranty</h3>
      <p>
        The App is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind, either express or
        implied.
      </p>

      <h3>9.2 Limitation of Liability</h3>
      <p>
        In no event shall we be liable for any indirect, incidental, special, consequential, or punitive damages arising
        out of your use of the App.
      </p>

      <h2>10. Indemnification</h2>
      <p>
        You agree to indemnify and hold us harmless from any claims, losses, liabilities, damages, expenses, and costs
        arising from your use of the App or violation of these Terms.
      </p>

      <h2>11. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of [Your Country/State], without
        regard to its conflict of law provisions.
      </p>

      <h2>12. Dispute Resolution</h2>
      <p>
        Any disputes arising out of or relating to these Terms or the App shall be resolved through arbitration located in Beirut, Lebanon, 
        in accordance with the rules of the Beirut Chamber of Commerce and Industry Arbitration Center.
      </p>

      <h2>13. Severability</h2>
      <p>
        If any provision of these Terms is found to be unenforceable or invalid, the remaining provisions shall remain in
        full force and effect.
      </p>

      <h2>14. Entire Agreement</h2>
      <p>
        These Terms constitute the entire agreement between you and us regarding the App and supersede any prior
        agreements.
      </p>

      <h2>15. Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us at:
      </p>
      <ul>
        <li>
          <strong>Email</strong>: jade1992amine@gmail.com
        </li>
        <li>
          <strong>Phone</strong>: +356 7962 9890
        </li>
        {/* <li>
          <strong>Address</strong>: [Company Address]
        </li> */}
      </ul>

      <p className="tos-footer">
        ---
        <br />
        By using our App, you acknowledge that you have read and understood these Terms of Service and agree to be
        bound by them.
      </p>
    </div>
  );
};

export default TermsOfService;
